import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import InnerHeading from "../../Global Functions/innerHeading";
import { ReactComponent as DealsIcon } from "../../Global Icons/Deals.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import SelectInput from "../../Global Functions/selectInput";
import TextInput from "../../Global Functions/textInput";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import AddImage from "../../Global Functions/addImage";
import MultipleImagesShowerModalGlobal from "../../Global Functions/multipleImagesShowerModalGlobal";
import {
  EditProperty,
  viewProperty,
} from "../../Redux/Actions/propertyActions";
import { viewUnitListNoPagination } from "../../Redux/Actions/unitsActions";
import PropertyCategoryHandler from "../../Commercial/Commercial Functions/propertyCategoryHandler";
import { ToFirstCapital, ToLowerCase } from "../../Utils/helpers";

const EditProperties = () => {
  const { id } = useParams();

  const editableFields = [
    "project_name",
    "project_type",
    "total_quantity",
    "no_of_kitchen",
    "no_of_bedroom",
    "no_of_bathroom",
    "no_of_balcony",
    "open_parking",
    "starting_price",
    "cover_parking",
    "unit",
    "unit_area",
    "price_per_sq_ft",
    "category",
    "about_property",
    "cover_photos",
    "images",
  ];

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { property } = useSelector((state) => state.properties || {});

  const [selectedCategory, setSelectedCategory] = useState("");

  const [projectPayload, setProjectPayload] = useState({
    added_by: "admin",
    property_id: id,
    project_id: property?.data?.project?._id,
    project_name: property?.data?.project?.project_name,
    project_type: property?.data?.project_type?._id,
    total_quantity: "",
    no_of_kitchen: "",
    no_of_bedroom: "",
    no_of_bathroom: "",
    no_of_balcony: "",
    open_parking: "",
    starting_price: "",
    cover_parking: "",
    unit: "",
    unit_area: "",
    price_per_sq_ft: "",
    category: property?.data?.category?._id,
    about_property: "",
    cover_photos: [],
    images: [],
  });

  useEffect(() => {
    const projectType = property?.data?.project_type?.name?.toLowerCase();
    if (projectType === "residential") {
      setUnitSelection(residentialUnits);
    } else if (projectType === "commercial") {
      setUnitSelection(commercialUnits);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [property?.data?.project_type?.name]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (property?.data) {
      setProjectPayload(property.data);
    }
  }, [property?.data]);

  useEffect(() => {
    if (property?.data?.project_name) {
      setProjectPayload((prevData) => ({
        ...prevData,
        project_name: property.data.project_name,
      }));
    }
  }, [dispatch, property?.data]);

  const handlerNavigation = () => {
    navigate("/manage_properties");
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setProjectPayload((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleAddImages = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) {
      return toast.error("Please Upload Image");
    }
    const responseUrl = await AddImage(uploadedImage);
    if (responseUrl) {
      const newImage = {
        url: responseUrl,
        index: projectPayload.images.length + 1,
      };
      setProjectPayload((prevData) => ({
        ...prevData,
        images: [...prevData.images, newImage],
      }));
    }
  };

  const handleSubmit = async (event) => {
    try {
      const cleanedPayload = Object.fromEntries(
        Object.entries(projectPayload).filter(([key]) =>
          editableFields.includes(key)
        )
      );

      const overAllPayload = {
        ...cleanedPayload,
        property_id: id,
        project_id: property?.data?.project?._id,
        project_name: property?.data?.project?.project_name,
        project_type: property?.data?.project_type?._id,
      };

      const response = await dispatch(EditProperty(overAllPayload));
      response.statusCode === 200
        ? navigate("/manage_properties")
        : toast.error(response?.message);
    } catch (error) {
      return toast.error(error?.message);
    }
  };

  const handleCoverImage = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) {
      return toast.error("Please Upload Image");
    }
    const responseUrl = await AddImage(uploadedImage);
    const newImage = {
      url: responseUrl,
      index: projectPayload.cover_photos.length + 1,
    };

    if (responseUrl) {
      setProjectPayload((prevData) => ({
        ...prevData,
        cover_photos: [...prevData.cover_photos, newImage],
      }));
    }
  };

  useEffect(() => {
    if (property?.data?.project_type?._id)
      dispatch(
        viewUnitListNoPagination({ filter: property?.data?.project_type?._id })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [property?.data?.project_type]);

  useEffect(() => {
    dispatch(viewProperty(id));
  }, [dispatch, id]);

  const { units } = useSelector((state) => state.units || {});

  const unitsList = units?.data || [];

  const commercialUnits = unitsList.filter(
    (unit) => unit?.project_type?.name?.toLowerCase() === "commercial"
  );

  const residentialUnits = unitsList.filter(
    (unit) => unit?.project_type?.name?.toLowerCase() === "residential"
  );

  const [unitSelection, setUnitSelection] = useState(residentialUnits);

  useEffect(() => {
    setSelectedCategory(property?.data?.category?.name_withoutspace);
  }, [property?.data]);

  const getPropertyData = (propData) => {
    setProjectPayload((prevData) => ({ ...prevData, ...propData }));
  };

  return (
    <MainLayout>
      <div className="bg-white grid-span-5 radius-20 padding-20 grid-template-2 gap-10 row-span-8">
        <InnerHeading
          Icon={DealsIcon}
          onClick={() => handlerNavigation()}
          heading="Edit Properties"
          buttonLabel="View Properties"
        ></InnerHeading>
        <TextInput
          label="Project Name"
          disabled
          type="text"
          value={
            property?.data?.project
              ? property.data.project.project_name
              : "No Data"
          }
        ></TextInput>
        <TextInput
          label="Project Type"
          disabled
          value={
            property?.data?.project_type
              ? property.data.project_type.name
              : "No Data"
          }
        ></TextInput>
        <TextInput
          label="RERA-ID"
          disabled
          value={
            property?.data?.project ? property.data.project.rera_id : "No Data"
          }
        ></TextInput>
        <TextInput
          label="Category"
          disabled
          value={
            property?.data?.category
              ? property.data.category.name_withoutspace
              : "No Data"
          }
        ></TextInput>
        <SelectInput
          placeholder="Select an Option"
          value={projectPayload?.unit?._id}
          required
          // options={
          //   unitSelection
          //     ? unitSelection.map((item) => ({
          //         label: item.name,
          //         value: item._id,
          //       }))
          //     : []
          // }
          options={
            units?.data
              ? units.data.map((item) => ({
                  label: item.name,
                  value: item._id,
                }))
              : []
          }
          name="unit"
          onChange={handleAddChange}
          label="Select Furnishing Unit"
        ></SelectInput>
        <TextInput
          name="unit_area"
          min={0}
          value={projectPayload?.unit_area}
          label="Area of Property(sq.ft)"
          type="number"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          name="price_per_sq_ft"
          min={0}
          value={projectPayload?.price_per_sq_ft}
          label="Price/ sq.ft"
          type="number"
          onChange={handleAddChange}
        ></TextInput>

        {/* <div></div>
        <div className="span2"></div>
        <TextInput
          name="no_of_kitchen"
          min={0}
          required
          label="No. Of Kitchen"
          type="number"
          value={projectPayload.no_of_kitchen}
          disabled={
            property?.data?.category?.name_withoutspace === "apartment"
              ? false
              : true
          }
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          name="no_of_bathroom"
          required
          min={0}
          label="No. Of Bathroom"
          type="number"
          value={projectPayload.no_of_bathroom}
          disabled={
            property?.data?.category?.name_withoutspace === "apartment"
              ? false
              : true
          }
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          name="no_of_balcony"
          min={0}
          required
          label="No. Of Balcony"
          value={projectPayload.no_of_balcony}
          disabled={
            property?.data?.category?.name_withoutspace === "apartment"
              ? false
              : true
          }
          type="number"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          name="no_of_bedroom"
          min={0}
          required
          label="No. Of Bedroom"
          value={projectPayload.no_of_bedroom}
          disabled={
            property?.data?.category?.name_withoutspace === "apartment"
              ? false
              : true
          }
          type="number"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          min={0}
          name="open_parking"
          value={projectPayload.open_parking}
          label="Open Parking"
          type="number"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          min={0}
          value={projectPayload.cover_parking}
          name="cover_parking"
          label="Cover Parking"
          type="number"
          onChange={handleAddChange}
        ></TextInput> */}

        <div className="grid-span-2 border-1-grey padding-10 border-10">
          {property?.data?.category?.name_withoutspace ? (
            <h3 className="margin-h-10">
              Specific Details -{" "}
              {ToFirstCapital(property?.data?.category?.name_withoutspace)}
            </h3>
          ) : (
            <h3>Specific Details</h3>
          )}
          {ToLowerCase(property?.data?.category?.name_withoutspace) ===
          "apartment" ? (
            <div className="grid-span-2">
              <div className="grid-template-2 gap-10">
                <TextInput
                  name="no_of_kitchen"
                  min={0}
                  required
                  label="No. Of Kitchen"
                  type="number"
                  // disabled={
                  //   project?.data?.categories?.map(
                  //     (item) => item.name === "apartment"
                  //   )
                  //     ? false
                  //     : true
                  // }
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  name="no_of_bathroom"
                  required
                  min={0}
                  label="No. Of Bathroom"
                  type="number"
                  // disabled={
                  //   project?.data?.categories?.map(
                  //     (item) => item.name === "apartment"
                  //   )
                  //     ? false
                  //     : true
                  // }
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  name="no_of_balcony"
                  min={0}
                  required
                  label="No. Of Balcony"
                  // disabled={
                  //   project?.data?.categories?.map(
                  //     (item) => item.name === "apartment"
                  //   )
                  //     ? false
                  //     : true
                  // }
                  type="number"
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  name="no_of_bedroom"
                  min={0}
                  required
                  label="No. Of Bedroom"
                  // disabled={
                  //   project?.data?.categories?.map(
                  //     (item) => item.name === "apartment"
                  //   )
                  //     ? false
                  //     : true
                  // }
                  type="number"
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  min={0}
                  name="open_parking"
                  label="Open Parking"
                  type="number"
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  min={0}
                  name="cover_parking"
                  label="Cover Parking"
                  type="number"
                  onChange={handleAddChange}
                ></TextInput>
              </div>
            </div>
          ) : null}
          <PropertyCategoryHandler
            category={property?.data?.category?.name_withoutspace}
            onChange={getPropertyData}
            propertyData={property?.data}
          ></PropertyCategoryHandler>
        </div>

        <TextInput
          name="starting_price"
          required
          min={0}
          label="Starting Price"
          type="number"
          value={projectPayload.starting_price}
          onChange={handleAddChange}
        ></TextInput>
        <div className="grid-span-2">
          <TextInput
            name="about_property"
            value={projectPayload.about_property}
            label="About Property"
            type="text"
            onChange={handleAddChange}
          ></TextInput>
        </div>
        <div>
          <TextInput
            forImage={true}
            htmlFor="cover_photos"
            span="Cover Image(Max 3)"
            disabled={projectPayload.cover_photos.length === 3 ? true : false}
            required
            onChange={(event) => handleCoverImage(event)}
            type="file"
            label="Click to Upload Image"
            id="cover_photos"
            name="cover_photos"
          ></TextInput>
          <div>
            <MultipleImagesShowerModalGlobal
              state={projectPayload.cover_photos}
              setState={setProjectPayload}
              fieldName="cover_photos"
            ></MultipleImagesShowerModalGlobal>
          </div>
        </div>
        <div>
          <TextInput
            forImage={true}
            htmlFor="images"
            onChange={(event) => handleAddImages(event)}
            type="file"
            span="Property Images"
            required
            label="Click to Upload Image"
            id="images"
            name="images"
          ></TextInput>
          <MultipleImagesShowerModalGlobal
            state={projectPayload.images}
            setState={setProjectPayload}
            fieldName="images"
          ></MultipleImagesShowerModalGlobal>
        </div>
        {/* <div>
          <TextInput
            forImage={true}
            htmlFor="cover_photo"
            span="Cover Image(Maximum 1)"
            required
            onChange={(event) => handleCoverImage(event)}
            type="file"
            label="Click to Upload Image"
            id="cover_photo"
            name="cover_photo"
            disabled={projectPayload.cover_photo ? true : false}
          ></TextInput>
          <ImageShowerModalGlobal
            state={projectPayload}
            setState={setProjectPayload}
            keyField="cover_photo"
            file={projectPayload.cover_photo}
          ></ImageShowerModalGlobal>
        </div>
        <div>
          <TextInput
            forImage={true}
            htmlFor="images"
            onChange={(event) => handleAddImages(event)}
            type="file"
            span="Project Images"
            required
            label="Click to Upload Image"
            id="images"
            name="images"
          ></TextInput>
          <MultipleImagesShowerModalGlobal
            state={projectPayload.images}
            setState={setProjectPayload}
          ></MultipleImagesShowerModalGlobal>
        </div> */}
        <div className="grid-span-2 flex-end">
          <Link to="/manage_properties">
            <button className="button-class-white">Cancel</button>
          </Link>
          <button className="button-class" onClick={() => handleSubmit()}>
            Save
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default EditProperties;
